// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__rIIf8","col":"styles_col__3bDHW"};